import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";

@Component({
  selector: 'sm-point-conversion',
  templateUrl: './point-conversion.component.html',
  styleUrls: ['./point-conversion.component.scss']
})
export class PointConversionComponent implements OnInit, OnDestroy {
  apisub: Subscription;
  pointCoversionRate: number = 1;
  constructor(
    private apiservice: ApiService,
    private ls: LoaderServiceService,
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private activemodal: MatDialogRef<PointConversionComponent>
  ) {
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_REWARD_POINT_CONVERSION_FOR_ENTITY
      ) {
        if (resdata.result) {
          this.pointCoversionRate =
            resdata.result.loyalty_points_conversion_rate ?? 0;
        }
        this.ls.showLoader = false;
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_SET_REWARD_POINT_CONVERSION_FOR_ENTITY
      ) {
        if (resdata.result) {
          this.ls.showLoader = false;
          this.activemodal.close({msg:'success'})
        }
      }
    });
  }

  ngOnInit(): void {
    this.apiservice.getRewardPountConversionForEntity(
      this.parentdata.entityHash,
    );
  }

  onsave() {
    let obj = {
      entity_hash: this.parentdata.entityHash,
      conversion_rate: this.pointCoversionRate,
    };

    this.ls.showLoader = true
    this.apiservice.setRewardPountConversionForEntity(obj)
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }
}
